var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgLeadRecord = function SvgLeadRecord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3a3 3 0 013-3h34a3 3 0 013 3v34a3 3 0 01-3 3H3a3 3 0 01-3-3V3z",
    fill: "#EA8F6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.019 16.006a3.003 3.003 0 100-6.006 3.003 3.003 0 000 6.006zM29.361 18.008H10.676c-.667 0-.934.834-.367 1.201l4.872 3.136c.233.167.367.468.267.735l-1.836 6.106c-.2.667.668 1.134 1.168.633l4.738-5.005c.267-.3.734-.3 1.001 0l4.738 5.005c.467.5 1.335.034 1.168-.633l-1.835-6.107a.702.702 0 01.267-.734l4.871-3.136c.567-.367.3-1.201-.367-1.201z",
    fill: "#fff"
  })));
};

export default SvgLeadRecord;